import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Categories from "./sections/Categories";
import Featured from "./sections/Featured";
import Guarantees from "./sections/Guarantees";
import Workshop from "./sections/Workshop";
import Touch from "./sections/Touch";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <Categories />
      <Featured />
      <Guarantees />
      <Workshop />
      <Touch />
    </div>;
}